<template>
    <div>

        <v-layout row justify-center>
            <v-dialog  v-model="mustShowTestPopup"  persistent max-width="70%" class="popup-scoring" id="close-upload-popup">
                <v-card class="popup-scoring">
                    <v-card-title class="headline">
                        <span class="font-weight-light">{{text("api.pro.tests.upload")}}</span>
                        <span  @click="hideTestPopup()" class="float-right"><v-icon class="font-weight-light">clear</v-icon></span>
                    </v-card-title>
                    <v-card-text>
                        <input type="file" ref="file" @change="onFileSelected">
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="onUpload" class="btn-test-pg" :disabled="!uploadTrue">{{text("api.button.ok")}}</v-btn>
                        <v-btn @click="hideTestPopup()">{{ text('api.button.cancel') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'TestPopup',
        data () {
            return {
                selectedFile: null,
                uploadTrue: false
            }
        },
        computed: {
            ...mapGetters({
                mustShowTestPopup: 'TestStore/getMustShowTestPopup',
                testTree: 'TestStore/getTestTree',
                products: 'ProductListStore/getProductList',
            }),
        },
        methods: {
            ...mapActions({
                showTestPopup: 'TestStore/showTestPopup'
            }),

            hideTestPopup() {
                this.$store.commit('TestStore/setMustShowTestPopup', false);
            },
            escapeKeyListener: function(evt) {
                if (evt.keyCode === 27) {
                    this.hideTestPopup();
                }
            },
            onFileSelected: function (event) {
                this.selectedFile = event.target.files[0];
                this.uploadTrue = event.target.files.length === 1;
            },
            onUpload() {
                this.$store.dispatch("TestStore/uploadJsonAndLoadTreeData", {
                    file: this.selectedFile
                })
                .then(() => {
                    this.hideTestPopup();
                    this.$store.commit('TestStore/setGetTreeData', false);
                    this.$router.push('/test-tree');
                });
            }

        },
        created: function() {
            document.addEventListener('keyup', this.escapeKeyListener);
        },
        destroyed: function() {
            document.removeEventListener('keyup', this.escapeKeyListener);
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .popup-scoring {

        &.card {
            padding: 0;

            .card__title {
                background-color: $color-brand-primary;
                display: block;
                padding: 20px 40px;

                .icon {

                    &:hover {
                        cursor: pointer;
                    }

                }
            }

            .card__text {
                padding: 40px;
            }

            .card__actions {
                padding: 15px 40px;
            }

        }

        p {
            font-size: $font-size-small;
            color: $color-headings-text;
            margin-bottom: 0;
        }

        .ambulance-scoring {
            position: relative;
            top: 7px;
            right: 7px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/professional/components/tests/UploadTestPopup.vue